import angular = require("angular");
import layoutRoutes = require("./layout.routes");
import shellController = require("./shell.controller");
import moment = require("moment");

export function initialize() {

    var layoutModule = angular
        .module("app.layout", ["ngMaterial", "ui.router", 'ui.router.upgrade'])
        .config(function ($mdDateLocaleProvider) {
            $mdDateLocaleProvider.formatDate = function (date) {
                return moment(date).format('DD-MM-YYYY');
            };
            $mdDateLocaleProvider.parseDate = function (dateString) {
                var m = moment(dateString, 'DD-MM-YYYY', true);
                return m.isValid() ? m.toDate() : new Date(NaN);
            };
        })

    layoutRoutes.initialize(layoutModule);
    shellController.initialize(layoutModule);
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/layout/layout.module.ts